<template>
    <div class="container">
        <nav>
                <router-link to="/">ETUSIVU</router-link>
                <router-link to="/conversation">DEMOKESKUSTELU</router-link>
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSd6f_TYtuLMLXUoUwj84LPRga-Lyo5XPyMBKfyZ_ozCIIZIuw/viewform?usp=sf_link">ARVOSTELE</a>
                <router-link to="/">KIRJAUTUMINEN</router-link>
        </nav>
        <div id="content">
            <img id="logo" src="../assets/Trigendadigi.png">
            <div id="box1" class="infoBox">
                <h1>Mitä tarkoittaa Trigenda PRO eli Trigenda dialogimenetelmä?</h1>
                <p>Trigenda keskustelumenetelmä ei ole nippu lomakkeita, vaan keskustelu käydään Trigenda PRO työvälinettä käyttämällä.
                    Trigenda on useiden eri alojen ammattilaisten käyttöön suunniteltu Suomessa kehitetty keskustelumenetelmä. Kyseessä on aktivoiva keskusteluprosessi,
                    joka ohjaa tavoitteellisen keskustelun alusta loppuun asiakaslähtöisesti, aina palautteen antoon saakka. Menetelmää käytetään työelämän tarpeissa,
                    sosiaali - ja terveydenhuollon kentällä, kouluissa opetus- ja oppilashuollon tehtävissä, rikosseuraamusalalla sekä terapiatyössä</p>
                <p>Trigenda PRO eli Trigenda dialogimenetelmä on monipuolinen ja useissa eri tilanteissa sovellettava keskustelumenetelmä, jonka käyttöön koulutetaan.</p>
                <p>Trigenda tuotteissa yhdistyvät suomalainen sosiaalialan huippuosaaminen ja tyylikäs suomalainen muotoilu.
                    Trigenda dialogimenetelmä on EU-tasolla tavaramerkkirekisteröity ja mallisuojattu tuotekokonaisuus.</p>
            </div>
            <div id="box2" class="infoBox">
                <h1>Mihin Trigenda dialogityömenetelmä perustuu?</h1>
                <p>Trigenda dialogimenetelmä pohjaa ajatukseen intuitiosta, yksilön mahdollisuuteen lähteä työstämään haastaviakin asioita helpommin konkreettisen työvälineen
                 ja toiminnallisuuden kautta. Työväline tarjoaa apua vaikeiden asioiden puheeksiottamiseen sekä auttaa keskustelijaa hahmottamaan oman elämänsä ilmiöitä ja
                 kokonaisuuksia. Trigenda dialogimenetelmä on sosiaalipedagoginen ja ratkaisukeskeinen konkreettinen työväline.</p>
                <p>Työmenetelmän ohjeissa työntekijä voi tutustua syvemmin teorioihin ja ajatuksiin menetelmän taustalla. Trigenda työväline sisältää useita erilaisia
                 käsitekorttikokonaisuuksia. Käsitekortteihin valitut käsitteet liittyvät oleellisesti ihmisen elämään ja elämän eri osa-alueisiin.
                  Työvälineen lisäosien tarjoamien käsitteiden avulla voidaan laajentaa ja monipuolistaa työskentelyä esimerkiksi eri kohderyhmien kanssa.</p>
            </div>
            <div id="box3" class="infoBox">
                <h1>Missä tilanteissa ammattilainen voi hyötyä Trigenda dialogimenetelmästä?</h1>
                <p>Menetelmän käyttäminen on helposti omaksuttavissa. Menetelmäkoulutus tarjoaa valmiudet käydä ohjattuja keskusteluja Trigenda menetelmän avulla sekä ideoita
                 menetelmän soveltamiseksi erilaisissa tilanteissa. Trigenda dialogimenetelmä tarjoaa laajat käyttömahdollisuudet asiakkaiden kanssa tehtävään keskustelutyöhön.
                 Trigenda dialogimenetelmä sopii useaan eri kohtaamistilanteeseen, useiden eri asiakasryhmien kanssa. Trigenda menetelmää voidaan käyttää niin yksilö- kuin pari
                  -ja ryhmäkeskustelutilanteissa. Menetelmän avulla voidaan työskennellä monella eri tavalla. Trigenda dialogimenetelmän avulla voidaan työstää pitkäkestoisia,
                   tavoitteellisia asiakasprosesseja kokonaisuudessaan. Menetelmä sopii hyvin esimerkiksi uuden asiakkaan kohtaamiseen, nopeaan asiakkaan tilanteen kartoittamiseen,
                    tavoitteiden asettamiseen, vaikeiden asioiden puheeksiottamiseen sekä palveluohjaukseen.</p>
            </div>
        </div>
        <footer>
            <p>TRIGENDADIGI</p>
            <p>demo 1</p>
            <p>OTA YHTEYTTÄ</p>
            <p>email: info@trigenda.fi</p>
        </footer>
    </div>
</template>

<script>

export default {
    name: 'TrigendaInfo',
    props: {
        msg: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
p {
  margin:0.5em;
}
nav {
    display: flex;
  background-color:#444444;
  width:100%;
  position:fixed;
  top:0;
  left:0;
  max-height:25%;
  overflow:hidden;
  z-index: 1;
  justify-content: center;
}
nav > a {
  color:white;
  text-decoration:none;
  padding: 1em 3em;
  margin: 0 0.1em;
  width: 10em;
  font-size: 0.9em;
}
nav>a:hover {
    color: #48A3A7;
}
footer {
  background-color:#444444;
  width:100%;
  color:white;
  margin-top: 3em;
  padding-top: 2em;
  padding-bottom: 2em;
  text-align: left;
}
footer > p {
  margin-left: 12vw;
}
body {
  min-height:100%;
  height:100%;
  font-family: "Bahnschrift", Times, serif;
  background: linear-gradient(180deg, rgba(255,255,255,1) 46%, rgba(174,174,174,1) 100%);
  width:100%;
}
#content {
  width:90%;
  display: inline-grid;
  grid-template-columns: auto;
  grid-template-rows: repeat(3, auto);
  justify-items: center;
  min-height: 100%;
  margin-top: 1em;
  grid-gap: 3em 0;
  text-align: left;
}
#box1 {
    background-color: rgba(77, 205, 213, 0.2);
    box-shadow: 0px 0px 15px #4DCDD5;
}
#box2 {
    background-color: rgba(104, 212, 89, 0.2);
    box-shadow: 0px 0px 15px #68D459;
}
#box3 {
    background-color: rgba(255, 147, 67, 0.2);
    box-shadow: 0px 0px 15px #FF9343;
}
#logo {
    width: 15vw;
    float: right;
    margin-left: 55%;
}
.infoBox {
    clear: none;
    padding: 0 2em;
    width: 70%;
}
.infoBox > h1 {
    font-size: 1.25em;
}
@media only screen and (max-width: 1000px) {
#logo {
  display: none;
}
#box1 {
  margin-top: 40px;
}
}

@media only screen and (max-width: 699px) {
nav {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
nav > a {
  padding: 0.8em 3em;
}
#upperContent {
  margin-top: 60px;
}
#box1 {
  margin-top: 60px;
}
}
@media only screen and (max-width: 500px) {
nav a{
  font-size: 11px;
  padding: 0.8em 2.5em;
  margin: 0 0.1em;
  width: 10em;
}
}
</style>
